const KEY = 'post_login_redirect';

export const rememberRedirect = (path) => sessionStorage.setItem(KEY, path);
export const getRedirect = () => sessionStorage.getItem(KEY) || '/calculator';
export const clearRedirect = () => sessionStorage.removeItem(KEY);
